var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXIconV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8704 7.07037C18.1633 6.77748 18.1633 6.3026 17.8704 6.00971C17.5775 5.71682 17.1026 5.71682 16.8097 6.00971L11.94 10.8794L7.07037 6.00971C6.77748 5.71682 6.3026 5.71682 6.00971 6.00971C5.71682 6.3026 5.71682 6.77748 6.00971 7.07037L10.8794 11.94L6.00971 16.8097C5.71682 17.1026 5.71682 17.5775 6.00971 17.8704C6.3026 18.1633 6.77748 18.1633 7.07037 17.8704L11.94 13.0007L16.8097 17.8704C17.1026 18.1633 17.5775 18.1633 17.8704 17.8704C18.1633 17.5775 18.1633 17.1026 17.8704 16.8097L13.0007 11.94L17.8704 7.07037Z",
    fill: "#525D71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconV2);
export default __webpack_public_path__ + "static/media/x-icon-v2.e336dd2984cf996a0f851a101cf13979.svg";
export { ForwardRef as ReactComponent };